export default {
	Prod: {
		apiDomain: "https://api.betwayafrica.com/api",
		apicDomain: "https://apic.betwayafrica.com/api",
		playerDomain: "https://synapse.betway.{tld}/player",
		authDomain: "https://www.betway.{tld}/appsynapse/auth",
		bettingDomain: "https://www.betway.{tld}/appsynapse/bet-api-sr",
		configDomain: "https://config.betwayafrica.com",
		kenticoContent: "https://cms1.betwayafrica.com/gmapi/Content/cmsget/",
		kenticoDomain: "https://cms1.betwayafrica.com",
		signalrDomain: "https://signalrapi.betwayafrica.com",
		sportsDomain: "https://synapse-sportsapi.betway.{tld}",
		universalDomain: "https://www.betway.{tld}/appsynapse/universal",
		wmsConfigFormDomain: "https://rowapic.gmgamingsystems.com/api/v2/Configuration/Forms",
		casinoApiDomain: "https://casinoapi.betwayafrica.com/api",
		casinoApiCdnDomain: "https://casinoapic.betwayafrica.com/api",
		graphqlUrl: "/graphql",
		loyalty: "https://uat-loyalty-external.betwayafrica.com",
		casinoEnv: "Production",
		env: "development",
	},
	Dev: {
		configDomain: "https://dev-config.betwayafrica.com",
		authDomain: "https://synapse-dev.betway.{tld}/auth",
		sportsDomain: "https://synapse-sportsapi-dev.betway.{tld}",
		bettingDomain: "https://www.betway.{tld}/bet-api",
		kenticoDomain: "http://content.gmgamingsystems.com.dv",
		kenticoContent: "//cms1.betwayafrica.com/gmapi/Content/cmsget",
		playerDomain: "https://synapse-dev.betway.{tld}/player",
		apiDomain: "http://api.betwayafrica.com.development/api",
		signalrDomain: "https://signalrapi.betwayafrica.com",
		universalDomain: "https://synapse-dev.betway.{tld}/synapsebets/universal-api",
		wmsConfigFormDomain: "https://rowapic.gmgamingsystems.com/api/v2/Configuration/Forms",
		graphqlUrl: "https://betway.afr-uat.sportsbackend.dev/graphql",
		loyalty: "https://uat-loyalty-external.betwayafrica.com",
		env: "development",
	},

	UAT: {
		configDomain: "https://config.betwayafrica.com",
		authDomain: "https://www.betway.{tld}/appsynapse/auth/",
		playerDomain: "https://www.betway.{tld}/appsynapse/player",
		sportsDomain: "https://synapse-sportsapi.betway.{tld}",
		bettingDomain: "https://www.betway.{tld}/appsynapse/bet-api",
		kenticoDomain: "https://cms1.betwayafrica.com",
		kenticoContent: "https://cms1.betwayafrica.com/gmapi/Content/cmsget/",
		apiDomain: "https://api.betwayafrica.com/api",
		signalrDomain: "https://signalrapi.betwayafrica.com",
		universalDomain: "https://www.betway.{tld}/appsynapse/universal",
		wmsConfigFormDomain: "https://rowapic.gmgamingsystems.com/api/v2/Configuration/Forms",
		graphqlUrl: "https://betway.afr.sportsbackend.net/graphql",
		loyalty: "https://uat-loyalty-external.betwayafrica.com",
	},
	SANDBOX: {
		apiDomain: "https://api.betwayafrica.com/api",
		authDomain: "https://synapse-qa.betway.{tld}/auth",
		playerDomain: "https://synapse.betway.{tld}/player",
		sportsDomain: "https://feeds-dev.ragingriver.io/_apis/sport-br",
		sportsDomainRadar: "https://feeds-dev.ragingriver.io/_apis/sport-br",
		bettingDomain: "https://synapse-uat.betway.{tld}/synapsebets/bet-api",
		configDomain: "https://sandbox-config.betwayafrica.com",
		kenticoContent: "https://cms1.betwayafrica.com/gmapi/Content/cmsget/",
		kenticoDomain: "https://cms1.betwayafrica.com",
		signalrDomain: "https://signalrapi.betwayafrica.com",
		signalrSports: "https://feeds-dev.ragingriver.io/_apis/public-hub",
		universalDomain: "https://synapse-qa.betway.{tld}/synapsebets/universal-api",
		wmsConfigFormDomain: "https://rowapic.gmgamingsystems.com/api/v2/Configuration/Forms",
		graphqlUrl: "https://betway.afr.sportsbackend.net/graphql",
		casinoEnv: "Production",
		env: "development",
	},
	QA: {
		apiDomain: "https://api.betwayafrica.com/api",
		authDomain: "https://synapse-uat.betway.{tld}/auth",
		playerDomain: "https://synapse-uat.betway.{tld}/player",
		sportsDomain: "https://synapse-sportsapi.betway.{tld}",
		sportsDomainRadar: "https://feeds-uat.ragingriver.io/_apis/sport-br",
		bettingDomain: "https://synapse-uat.betway.{tld}/synapsebets/bet-api",
		bettingDomainRadar: "https://synapse-uat.betway.co.tz/synapsebets/bet-api-sr",
		configDomain: "https://qa-config.betwayafrica.com",
		kenticoContent: "https://cms1.betwayafrica.com/gmapi/Content/cmsget/",
		kenticoDomain: "https://cms1.betwayafrica.com",
		signalrDomain: "https://signalrapi.betwayafrica.com",
		signalrSportsRadar: "https://feeds-uat.ragingriver.io/_apis/pub-hub-br",
		universalDomain: "https://synapse-uat.betway.{tld}/synapsebets/universal-api",
		wmsConfigFormDomain: "https://rowapic.gmgamingsystems.com/api/v2/Configuration/Forms",
		graphqlUrl: "https://betway.afr.sportsbackend.net/graphql",
		loyalty: "https://uat-loyalty-external.betwayafrica.com",
		casinoEnv: "Production",
		env: "development",
	},
};
